/*@ngInject*/
const WizardBreadcrumbsDirective = function (submissionConstant, coreConstant) {

    var linkFunction = function ($scope, $elm, $attrs) {

        var $window = $(window),
            handleResize = function () {
                var maxSize = $scope.breadcrumbsViewModel.items.length * 66,
                    stepsContainer = $elm.find('.wizardSteps');
                if (stepsContainer.width() < maxSize) {
                    stepsContainer.addClass('narrow');
                    $scope.breadcrumbsViewModel.isNarrow = true;
                } else {
                    stepsContainer.removeClass('narrow');
                    $scope.breadcrumbsViewModel.isNarrow = false;
                }
            };

        $scope.$on(coreConstant.event.ACTION_BUTTONS_PROCESSING_COMPLETED, handleResize);
        $scope.$on(submissionConstant.event.REFRESH_SUBMISSION, handleResize);

        $window.on('resize.breadcrumbs', _.debounce(handleResize, 200));

        $scope.$on('$destroy', function () {
            $window.off('resize.breadcrumbs', handleResize);
        });

        $scope.$watch('breadcrumbsViewModel.items', handleResize);
    };

    return {
        restrict: 'E',
        replace: true,
        controller: 'wizardBreadcrumbsController',
        scope: {
            submissionId: '<',
            quoteId: '<',
            reportId: '<',
            policyIssuanceId: '<',
            proposalId: '<',
            policyCancellationId: '<',
            endorsementId: '<',
            policyId: '<',
            policyRewriteId: '<',
            progressLabel: '<'
        },
        link: linkFunction,
        templateUrl: '/wizard/breadcrumbs/breadcrumbs.tpl.html'
    };
};

angular.module('gw-um-submission')
    .directive('wizardBreadcrumbs', WizardBreadcrumbsDirective);
